// assets
import { IconFiles } from '@tabler/icons';
import permissioncheck from 'utils/permissioncheck';

// ==============================|| LEARNING MENU ITEMS ||============================== //

const children = [
  {
    id: 'file',
    perm: 'filevideo.read',
    title: 'Bank File Video',
    type: 'item',
    url: '/learning/file',
    icon: IconFiles,
    breadcrumbs: false
  }
];

const bank = {
  id: 'bank',
  title: '',
  type: 'group',
  children: []
};

children.forEach((element) => {
  if (permissioncheck(element.perm)) {
    bank.children.push(element);
  }
});

export default bank;
